import {asset} from 'imba';
import url from './easter.jpg';
export default asset({
	url: url,
	type: 'image',
	width: 2048,
	height: 1365,
	toString: function(){ return this.url;}
})